import { render, staticRenderFns } from "./IpdReport.vue?vue&type=template&id=182a602e&scoped=true"
import script from "./IpdReport.vue?vue&type=script&lang=js"
export * from "./IpdReport.vue?vue&type=script&lang=js"
import style0 from "./IpdReport.vue?vue&type=style&index=0&id=182a602e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a602e",
  null
  
)

export default component.exports